import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Typography, Spin, Tag, Table } from 'antd';
import {
  SafetyCertificateOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  UserOutlined,
  BellOutlined,
} from '@ant-design/icons';
import { govtAdminAPI, adminAPI } from '../services/api';

const { Title, Text } = Typography;

const Dashboard: React.FC = () => {
  const [stats, setStats]   = useState<any>(null);
  const [exams, setExams]   = useState<any[]>([]);
  const [userCount, setUserCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      govtAdminAPI.getStats().then(r => setStats(r.data?.data ?? r.data)).catch(() => {}),
      govtAdminAPI.getExams().then(r => {
        const data = r.data?.data ?? r.data;
        setExams(Array.isArray(data) ? data : []);
      }).catch(() => {}),
      adminAPI.getUsers().then(r => setUserCount(Array.isArray(r.data) ? r.data.length : 0)).catch(() => {}),
    ]).finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><Spin size="large" /></div>;

  const statCards = [
    { title: 'Govt Exams',      value: exams.length,                icon: <SafetyCertificateOutlined />, color: '#1D4ED8' },
    { title: 'Total Questions', value: stats?.totalQuestions ?? 0,  icon: <QuestionCircleOutlined />,    color: '#059669' },
    { title: 'Active Tests',    value: stats?.totalTests ?? 0,      icon: <FileTextOutlined />,          color: '#D97706' },
    { title: 'Total Students',  value: userCount,                   icon: <UserOutlined />,              color: '#7C3AED' },
    { title: 'Total Attempts',  value: stats?.totalAttempts ?? 0,   icon: <BellOutlined />,              color: '#0891B2' },
  ];

  const examColumns = [
    { title: 'Exam', dataIndex: 'name', key: 'name', render: (v: string) => <Text strong>{v}</Text> },
    { title: 'Code', dataIndex: 'code', key: 'code', render: (v: string) => v ? <Tag color="blue">{v}</Tag> : '—' },
    { title: 'Duration (min)', dataIndex: 'duration_minutes', key: 'd', render: (v: number) => v ?? '—' },
    {
      title: 'Status', dataIndex: 'is_active', key: 'status',
      render: (v: boolean) => <Tag color={v !== false ? 'green' : 'red'}>{v !== false ? 'Active' : 'Inactive'}</Tag>,
    },
  ];

  return (
    <div>
      <Title level={2} style={{ marginBottom: 4 }}>NammaPrep Dashboard</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Karnataka Government Exam Preparation Platform
      </Text>

      <Row gutter={[16, 16]}>
        {statCards.map(card => (
          <Col xs={24} sm={12} lg={8} xl={4} key={card.title}>
            <Card hoverable>
              <Statistic
                title={card.title}
                value={card.value}
                prefix={card.icon}
                valueStyle={{ color: card.color, fontSize: 28 }}
              />
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        title={<span><SafetyCertificateOutlined style={{ marginRight: 8, color: '#1D4ED8' }} />Government Exams</span>}
        style={{ marginTop: 24 }}
        extra={<Text type="secondary">{exams.length} exam{exams.length !== 1 ? 's' : ''} configured</Text>}
      >
        <Table
          dataSource={exams}
          columns={examColumns}
          rowKey="id"
          pagination={false}
          size="middle"
          locale={{ emptyText: 'No govt exams found. Go to Govt Exams to add one.' }}
        />
      </Card>
    </div>
  );
};

export default Dashboard;
